import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './core/services/error.service';
import { LoggingService } from './core/services/logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly errorService = inject(ErrorService);
  private readonly loggingService = inject(LoggingService);

  handleError(error: unknown): void {
    this.errorService.hideToastr();

    if (error instanceof HttpErrorResponse) {
      this.errorService.handleError(error);
    } else {
      // A non-HTTP runtime error (null deref, mapping bug) is an unexpected failure, not a
      // missing page — route to a generic 500 so real bugs aren't masked as "Page not found".
      this.errorService.navigateToErrorPage('Prišlo je do nepričakovane napake.', 500);
    }

    this.loggingService.logError(
      error instanceof HttpErrorResponse || error instanceof Error ? error : new Error(String(error)),
    );
  }
}
